module.exports = __webpack_public_path__ + "img/bri.dc60e9c5.png";